import { IProfileData } from "../profile/interface";

export const isProfileDataCompleted = (profileData: IProfileData): boolean => {
  if (!profileData) return;
  let isProfileDataCompleted: boolean = true;

  const removeEmptyData = (data: IProfileData) => {  
    const updatedData = {};
    Object.keys(data).forEach(function (key: string) {
      if(data[key] && typeof data[key] === "object") {
        updatedData[key] = removeEmptyData(data[key]);
      } else if (data[key] != "") {
        updatedData[key] = data[key];
      }
    });
    return updatedData;
  }

  const updatedProfileData = removeEmptyData(profileData);

  const requiredAddressField = {
    "key": "addresses",
    "subdata": ["pinCode" ]
  }
    
  const requiredProfileData = ["userId", "name", "mobile", requiredAddressField];

  interface IRequiredSubData {
    key: string
    subdata: (string | IRequiredSubData)[] 
  }


  const validateProfileData = (requiredProfileData: (string | IRequiredSubData)[], updatedProfileData) => {
     const filteredData: (string | IRequiredSubData)[] = requiredProfileData?.filter((data: string | IRequiredSubData) => {
        if(typeof data != "object"){
          if(updatedProfileData[data]){
            return false;
          }else{
            return true;
          }
        }else{
         const { key, subdata } = data;
         if(updatedProfileData[key]){
            Object.keys(updatedProfileData[key]).forEach(function (value: string, index: number) {
              if(updatedProfileData[key]){
                validateProfileData(subdata, updatedProfileData[data.key][index]);
              }else{
                return true;
              }
            });
         }else{
          return true;
         }
        }
     });

     if(filteredData.length > 0){
      isProfileDataCompleted = false;
     }
  }
  validateProfileData(requiredProfileData, updatedProfileData);

  return isProfileDataCompleted;
};
